<template>
  <div>
    <label
      class="input__label"
      :for="id"
    >
      {{ translate(label) }} <span v-if="block.is_required">*</span>
    </label>

    <input-tel
      class="margin__t--6"
      v-model="model"
      :id="id"
      :placeholder="translate(placeholder)"
      :v="validator"
    />
  </div>
</template>

<script setup>
import { defineAsyncComponent, inject } from 'vue'
import { useModule } from '@/composables/app/useModule'
import { useProcedureBlockValidator } from '@/composables/modules/procedures'
import { useI18n } from '@/vendors/i18n'

const InputTel = defineAsyncComponent(() => import('&/atoms/InputTel'))

const { block } = defineProps({
  block: { type: Object, required: true }
})

const procedure_execution = inject('procedure_execution')

const { translate } = useI18n()
const { label, placeholder, model, id } = useModule({ component: block, parent: procedure_execution })
const { validator } = useProcedureBlockValidator({ validations: block.mandatory, state: model })
</script>
